import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatLocaledSourceType,
  RECOMMENDATION_TYPES,
  RECOMMENDATION_SOURCE_FOR_SORT_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

const getLocaledSources = (
  recommendedSources,
  i18n
) => {
  const localedSources = _.map(
    recommendedSources,
    source => (formatLocaledSourceType(i18n, source))
  );
  return localedSources.join(', ');
};

export class RecommendedBecauseColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType }) {
    const title = recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD ?
      i18n.getString('Details_View_RecommendedFrom_BMA') : i18n.getString('Details_View_GeneratedFrom');

    super({
      name: 'RecommendedFrom',
      property: 'Opportunities/RecommendedFrom',
      title,
      bodyClasses: ['grid-column-RecommendedFrom'],
      colClasses: ['col-longText'],
      sortable: RECOMMENDATION_SOURCE_FOR_SORT_TYPES[recommendationType],
      helpId: recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD ?
        '' : 'Pop_BA_Recommendations_GeneratedFrom',
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.i18n = i18n;
  }

  get property() {
    const { i18n } = this;
    return {
      get(item) {
        return getLocaledSources(
          _.chain(item.Opportunities).first().result('SourcesForBingAdsWebUi').value(),
          i18n
        );
      },
      key: 'Opportunities/RecommendedFrom',
    };
  }
}
